import React from 'react';
import { Link } from 'react-router-dom';

const SOLUTIONS_DATA = [
  {
    title: 'ERP Solutions',
    desc: 'Connect core business functions, sales, purchasing, inventory & financial records.',
    to: '/solutions#sol-erp',
    accentColor: '#1a2f6e', // Navy
    badgeBg: 'bg-[#1a2f6e]/10 text-[#1a2f6e] border border-[#1a2f6e]/20 group-hover:bg-[#1a2f6e] group-hover:text-white',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
      </svg>
    ),
  },
  {
    title: 'HRM Solutions',
    desc: 'Manage employee profiles, attendance, leave requests, payroll & workforce processes.',
    to: '/solutions#sol-hrm',
    accentColor: '#4caf50', // Green
    badgeBg: 'bg-[#4caf50]/10 text-[#4caf50] border border-[#4caf50]/20 group-hover:bg-[#4caf50] group-hover:text-white',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
  },
  {
    title: 'CRM Solutions',
    desc: 'Organize customer relationships, lead tracking, tasks & service activity history.',
    to: '/solutions#sol-crm',
    accentColor: '#0d9488', // Teal
    badgeBg: 'bg-[#0d9488]/10 text-[#0d9488] border border-[#0d9488]/20 group-hover:bg-[#0d9488] group-hover:text-white',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    ),
  },
  {
    title: 'LMS Solutions',
    desc: 'Manage learning content, corporate training programs, assessments & progress tracking.',
    to: '/solutions#sol-lms',
    accentColor: '#f97316', // Orange
    badgeBg: 'bg-[#f97316]/10 text-[#f97316] border border-[#f97316]/20 group-hover:bg-[#f97316] group-hover:text-white',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0112 20.055a11.952 11.952 0 01-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
      </svg>
    ),
  },
  {
    title: 'Custom Business Applications',
    desc: 'Purpose-built software designed around unique operational workflows & client portals.',
    to: '/solutions#sol-custom',
    accentColor: '#1a2f6e', // Navy
    badgeBg: 'bg-[#1a2f6e]/10 text-[#1a2f6e] border border-[#1a2f6e]/20 group-hover:bg-[#1a2f6e] group-hover:text-white',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
  },
];

const SolutionsDropdown = ({ closeMenu, handleMouseEnter, handleMouseLeave }) => {
  return (
    <div
      className="sipl-mega-dropdown-menu rounded-2xl bg-white shadow-2xl p-4 p-md-5"
      style={{
        position: 'absolute',
        top: 'calc(100% + 12px)',
        left: '-120px',
        width: '720px',
        maxWidth: '92vw',
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: '1rem',
        boxShadow: '0 25px 60px -15px rgba(15, 23, 42, 0.18), 0 0 0 1px rgba(226, 232, 240, 0.9)',
        zIndex: 9999,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Header Bar */}
      <div className="d-flex align-items-center justify-content-between pb-3 mb-3 border-b border-slate-100">
        <div className="d-flex align-items-center gap-2">
          {/* Logo Color Accent Dots */}
          <span className="w-2.5 h-2.5 rounded-full bg-[#1a2f6e]"></span>
          <span className="w-2.5 h-2.5 rounded-full bg-[#4caf50]"></span>
          <span className="w-2.5 h-2.5 rounded-full bg-[#0d9488]"></span>
          <span className="w-2.5 h-2.5 rounded-full bg-[#f97316]"></span>
          <span
            className="text-uppercase font-mono font-bold tracking-widest ms-1"
            style={{ fontSize: '11px', letterSpacing: '0.1em', color: '#1a2f6e', fontWeight: 800 }}
          >
            ENTERPRISE BUSINESS SOLUTIONS
          </span>
        </div>
        <Link
          to="/solutions"
          onClick={closeMenu}
          className="text-xs font-bold text-[#0d9488] hover:text-[#1a2f6e] text-decoration-none no-underline transition-colors"
          style={{ color: '#0d9488', textDecoration: 'none', fontWeight: 700, fontSize: '0.78rem' }}
        >
          View All Solutions →
        </Link>
      </div>

      {/* Bootstrap 2-Column Grid */}
      <div className="row g-3">
        {SOLUTIONS_DATA.map((sub) => (
          <div className="col-12 col-md-6" key={sub.title}>
            <Link
              to={sub.to}
              onClick={closeMenu}
              className="d-flex align-items-start gap-3 p-2.5 rounded-xl text-decoration-none group hover:bg-slate-50 transition-colors"
              style={{ textDecoration: 'none', color: '#0f172a' }}
            >
              {/* Brand Logo Colored Icon Box */}
              <div
                className={`w-9 h-9 rounded-xl d-flex align-items-center justify-content-center flex-shrink-0 transition-transform duration-200 group-hover:scale-105 ${sub.badgeBg}`}
                style={{ minWidth: '36px', minHeight: '36px' }}
              >
                {sub.icon}
              </div>

              <div className="flex-grow-1">
                <div
                  className="text-sm font-bold text-slate-900 group-hover:text-[#0d9488] transition-colors leading-tight"
                  style={{ color: '#0f172a', fontWeight: 700, fontSize: '0.875rem', lineHeight: '1.25' }}
                >
                  {sub.title}
                </div>
                <div
                  className="text-xs text-slate-500 font-normal leading-relaxed mt-1"
                  style={{ color: '#64748b', fontSize: '0.75rem', fontWeight: 400, lineHeight: '1.4' }}
                >
                  {sub.desc}
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      {/* Footer Strip */}
      <div className="mt-4 pt-3 border-t border-slate-100 d-flex align-items-center justify-content-between text-xs bg-slate-50 p-3 rounded-xl">
        <div className="d-flex align-items-center gap-2">
          <span className="font-semibold text-slate-700" style={{ color: '#334155', fontWeight: 600 }}>
            Looking for modular business software?
          </span>
        </div>
        <Link
          to="/contact"
          onClick={closeMenu}
          className="font-bold text-[#0d9488] hover:text-[#1a2f6e] text-decoration-none no-underline"
          style={{ color: '#0d9488', fontWeight: 700, textDecoration: 'none' }}
        >
          Request a Consultation →
        </Link>
      </div>
    </div>
  );
};

export default SolutionsDropdown;
